import React from 'react';
import { Container, Button, Card, Form, Row, Col } from 'react-bootstrap';
import { WidgetsOutlined } from '@material-ui/icons';
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react';
import { parseDateBR } from 'helpers/date.js';

const Historic = ({
    action
}) => {
    return (<>
        <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 col-12 row">
            <Row className="text-center">
                <WidgetsOutlined className="icon-title" />
                <h5 className="title-dashboard">Histórico</h5>
            </Row>
            <Timeline lineColor={'#e3e3e3'}>
                {action.action_histories.map((history, k) => {
                  history.user = history.user ?? {name: "Sistema", email: "Sistema"}
                  return (
                      <TimelineItem
                          key={k}
                          dateText={parseDateBR(history.created_at)}
                          dateInnerStyle={{ background: '#D8232F', color: '#fff' }}
                          bodyContainerStyle={{
                              background: 'rgb(255 255 255)',
                              padding: '20px',
                              borderRadius: '8px',
                              boxShadow: '0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)',
                          }}
                      >
                          <p className="text-dark"><small><b>Usuário:</b> {history.user.name}</small></p>
                          <p className="text-dark"><small><b>E-mail:</b> {history.user.email}</small></p>
                          <p className="text-dark"><small><b>Status:</b> {history.action_status.name}</small></p>
                          <p className="mb-0 text-dark">{history.description}</p>
                      </TimelineItem>
                  )
                })}
            </Timeline>
        </Card.Body>
    </>);
};

export default Historic;
